import axios from 'axios';
import { CLIENT } from "./constants";

const apiClient = axios.create({ baseURL: CLIENT.baseUrl });

const fetchDecorationTypes = () => apiClient.get('/decorations/types');

const fetchDecorations = (typeId, page) => apiClient.get(`/decorations/search?typeId=${typeId}&page=${page}`);

const doLogin = (credentials) => apiClient.get(`/login?user=${credentials.user}&password=${credentials.password}`);

const postDecoration = (formBody) => apiClient.post(`/decoration/post`, formBody)

export {
    fetchDecorationTypes,
    fetchDecorations,
    doLogin,
    postDecoration
}